module.exports = __webpack_public_path__ + "static/img/noSite.0575d078.png";